import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import React, { Component } from 'react'
import Api from '../../customlib/Api';
import axios from 'axios';
import Global from '../../customlib/Global';
import ConversationListItem from '../ConversationListItem';
import MessageListViewer from '../MessageListViewer';

class ChatViewer extends Component {
    state = { 
        contactList: [],
        selectedContact: null,
        isLoadingContactList: false
    } 

    handleSelectContact = (contact) => {
        this.setState({selectedContact: contact});
    }

    loadContactList = () => {
        this.setState({isLoadingContactList: true}, () => {
            const params = {
                custNumbers: this.props.selectedAgent?.leads?.filter(lead => [Global.labelCancel(), Global.labelPending()].includes(lead.label)).map(lead => lead.from)
                // custNumbers: this.props.selectedAgent?.leads?.map(lead => lead.from)
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.contactListByNumbers(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                let list = [];
                data.data.forEach(contact => {
                    list.push(Global.generateItemConversation(contact));
                });

                this.setState({contactList: list, isLoadingContactList: false});
            })
            .catch((error) => {
                this.setState({isLoadingContactList: false});
                console.error("There was an error!", error);
            });
        });
    }
        
    componentDidMount(){
        this.loadContactList();
    }

    render() { 
        return (
            <Box>
                <Grid container spacing={1}>
                    <Grid item xs={3}>
                        <Typography variant="span" sx={{fontWeight: "bold"}}>
                            Contact List
                        </Typography>
                        <Box sx={{backgroundColor: "#f9dcf6", height: "70vh", overflowY: "auto", pt: "5px", pb: "5px", borderRadius: "5px"}}>
                            
                            <LinearProgress style={{display: this.state.isLoadingContactList ? 'block' : 'none'}} />

                            {this.state.contactList.length === 0 && !this.state.isLoadingContactList && (
                                <Box sx={{p: 2, textAlign: "center"}}>No contacts found for the selected agent's leads.</Box>
                            )}

                            {this.state.contactList.map(contact => (
                                <ConversationListItem key={contact.id} data={contact} onSelect={this.handleSelectContact} isSelected={this.state.selectedContact?.id === contact.id} />    
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={9}>
                        {
                            this.state.selectedContact ? (
                                <MessageListViewer currentConversation={this.state.selectedContact} onSelect={() => {}} />
                            ) : (
                                <Box sx={{p: 2, textAlign: "center"}}>Please select a contact to view messages.</Box>
                            )
                        }
                    </Grid>
                </Grid>
            </Box>
        );
    }
}
 
export default ChatViewer;